import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router";
import moment from "moment";
import { url } from "../../../Utilities/url";
import { func } from "../../../Utilities/logFunc";
import { getHeaderApi, requestContestJoin } from "../../../Utilities/controller";
import PayIcon from '../../../assets/images/pay-icon-svg.svg'
import TeamRegisterModal from "../Tournament/TeamRegisterModal";
import { toast } from "react-toastify";
import { errors } from "../../../Utilities/error";
import D11Gold from '../../../assets/images/premium_logo.png'
import Champion from '../../../assets/new-images/gamerji-premium-logo.png'
import { useProfileDataContext } from "../ProfileContext";
import { useTranslation } from "react-i18next";
import { eventTracking } from "../../../firebaseAnalytics";
import { events } from "../../../Utilities/appEvents";

import GoogleAds from "../../../Components/GoogleAds/GoogleAds";

const ContestConfirmationModel = ({
  showContestConfirmationModal,
  setShowContestConfirmationModal,
  tournaments,
  walletData,
  userInGameName,
  setShowJVC,
  setShowPremiumPopupContest
}) => {
  // let premiumUser = JSON.parse(localStorage.getItem("premiumUser"))

  // var user_data = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const { t } = useTranslation();

  func("contest Username", userInGameName)
  const [show, setShow] = useState(showContestConfirmationModal);
  const [isLoading, setLoading] = useState(false);
  const [showTeamRegisterModal, setShowTeamRegisterModal] = useState(false);
  const [postData, setPostData] = useState(null);
  const [noOfPlayer, setNoOfPlayer] = useState(0);
  const [game, setGame] = useState("");
  const { profileData, updateProfileData, premiumUser } = useProfileDataContext()
  const [contestDisabled, setContestDisabled] = useState(false);

  const handleClose = () => {
    setShowContestConfirmationModal((prev) => false);
    setShow(false);
    if (setShowJVC)
      setShowJVC(false)
  };

  const handlerJoinContest = async () => {
    setContestDisabled(true)
    // console.log(profileData)
    const payload = {
      joinedDate: new Date(),
      JoinedTimestamp: new Date().getTime(),
      contest: tournaments?._id,
      inGameUserName: userInGameName,
      user: profileData?.item.user_id,
    };

    if (tournaments?.gameTypeAry?.players > 1) {
      setNoOfPlayer(tournaments?.gameTypeAry?.players || 0);
      setPostData(payload);
      console.log(tournaments)
      setGame(tournaments?.gameAry?.[0]?._id);
      setShowTeamRegisterModal(true);
      setContestDisabled(false)
    } else {
      if (!premiumUser && walletData?.walletBalance < walletData?.toPay) {
        toast.error("Insufficient Balance")
        navigate('/home/coin-store')
      }
      else {
        setLoading(true);
        try {
          const res = await requestContestJoin(payload);
          if (res?.data?.success) {
            const resProfile = await getHeaderApi();
            updateProfileData(resProfile?.data)
            toast.success(res?.data[0]?.msg)
            func("requestContestJoin", res?.data.data[0].param.item._id);
            setLoading(false);
            setShow(false);
            if (setShowJVC)
              setShowJVC(false)
            setShowContestConfirmationModal((prev) => false);
            navigate("/home/contest-details/" + tournaments?._id);
            eventTracking(events.join_contests, {
              GJ_GameName: tournaments?.gameAry?.[0]?.name,
              GJ_GameType: tournaments?.gameTypeAry?.name,
              GJ_GameID: tournaments?.gameAry?.[0]?._id,
              GJ_UserID: profileData?.item.user_id,
              GJ_ContestID: tournaments?._id
            });

          } else {
            setLoading(false);
            setShowContestConfirmationModal((prev) => false);
            if (res?.response?.data?.errors?.[0]?.data == "events.validation.MAX_FREE_TRANSACTION" || res?.response?.data?.errors?.[0]?.data == "ALREADY_JOINED_MAX_FREE_TRANSACTION" || res?.response?.data?.errors?.[0]?.msg == "events.validation.MAX_FREE_TRANSACTION" || res?.response?.data?.errors?.[0]?.msg == "ALREADY_JOINED_MAX_FREE_TRANSACTION") {
              setShowPremiumPopupContest(true)
            }
          }
        } catch (error) {
          // console.log("contest confirmation")
          if (error?.response?.data?.errors?.[0]?.data == "events.validation.MAX_FREE_TRANSACTION" || error?.response?.data?.errors?.[0]?.data == "ALREADY_JOINED_MAX_FREE_TRANSACTION") {
            setShowPremiumPopupContest(true)
          }


          else {
            if (error?.response?.data?.errors?.[0]?.data == "events.validation.MAX_FREE_TRANSACTION" || error?.response?.data?.errors?.[0]?.data == "ALREADY_JOINED_MAX_FREE_TRANSACTION") {
              setShowPremiumPopupContest(true)
            }
            else
              toast.error(error?.response?.data?.errors?.[0]?.msg);

          }
          setShowContestConfirmationModal((prev) => false);
          setLoading(false);
          setContestDisabled(false)

        }
      }
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className={premiumUser ? "premiumUserTournamentModal tournamentModal modal fade" : "tournamentModal modal fade "}
        id={tournaments?._id}
        centered
      >
        <Modal.Body className={`${premiumUser ? "bg-premium text-light" : ""}`}>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          ></button>
          <div class={`row justify-content-center ${premiumUser ? "bg-premium text-light" : ""}`}>
            <div class="col-11 px-lg-4">
              {
                premiumUser ?
                  <div className="text-center">
                    <img style={{ width: '7.5rem', height: '7.5rem' }} src={D11Gold} />
                    {/* <img  style={{width:'7.5rem', height:'7.5rem'}} src={localStorage.getItem("planName") == "Grandmaster" ? D11Gold : Champion} />  */}

                    <h2 className='d11-premium mt-2  mb-4'>{t("tournaments.premium")}</h2>
                  </div>
                  : ""

              }
              <div class="title">
                <h3 class={premiumUser ? "text-center bodyBoldFont mb-4 pb-3 text-white" : "text-center bodyBoldFont mb-4 pb-3 text-dark"}>
                  {tournaments?.title}
                </h3>
              </div>
              <div class=" text-center">
                <div class="d-flex justify-content-between fw-normal">
                  <h4 class={`mb-3 fw-normal ${premiumUser ? "text-light" : "text-dark"}`}>
                    {tournaments?.gameAry[0]?.name} -{" "}
                    {tournaments?.gameTypeAry?.name}
                  </h4>
                  <h4 class={`mb-3 fw-normal ${premiumUser ? "text-light" : "text-dark"}`}>
                    <span>
                      {moment(tournaments?.date).format("Do MMM YYYY")}
                    </span>
                    <span>
                      {" "}
                      {moment(tournaments?.dateTime).format("hh:mm A")}
                    </span>
                  </h4>
                </div>
                <div class="bg-primary-color-red text-white p-4 text-start">
                  <h3 class="mb-2 bodyBoldFont">{t("contest.confirmation")}</h3>
                  <h4 class="mb-0 d-flex align-items-center text-white">
                    {tournaments?.currency?.[0]?.inCurrency?.code === "D11" ? t("contest.diamond_balance") : t("contest.coin_balance")}  =
                    <span class="icon px-2 ">
                      <img
                        class="icon-24 "
                        src={
                          url?.imageUrl +
                          tournaments?.currency?.[0]?.inCurrency?.img?.default
                        }
                        alt=""
                      />
                    </span>
                    {" "}
                    {walletData?.walletBalance}
                  </h4>
                </div>
                <div class="d-flex flex-column text-start mt-4 pt-2">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between px-0 py-3">
                      <h4 class={`bodyBoldFont mb-0 ${premiumUser ? "text-light" : ""}`}>{t("contest.entry_fee")}</h4>
                      <h4 class={` mb-0 ${premiumUser ? "text-light" : ""}`}>
                        {
                          tournaments?.entryFee > 0 ? <span class="icon me-2 ">
                            <img
                              src={
                                url.imageUrl +
                                tournaments?.currency[0]?.inCurrency?.img?.default
                              }
                              class="icon-24 "
                              alt=""
                            />
                          </span>
                            : ""
                        }

                        {/* {tournaments?.entryFee > 0 && !premiumUser ? tournaments?.entryFee : t("tournaments.free")} */}
                        {tournaments?.entryFee > 0 ? tournaments?.entryFee : t("tournaments.free")}
                      </h4>
                    </li>
                    <li class="list-group-item d-flex justify-content-between px-0 py-3">
                      <h4 class={`bodyBoldFont mb-0 ${premiumUser ? "text-light" : ""}`}>
                        <span class="icon me-2 bg-accent-color-2 p-1 pb-0">
                          {/* <img
                            class="icon-24 "
                            src={PayIcon}
                            alt=""
                          /> */}
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                            <g clip-path="url(#clip0_2389_45009)">
                              <path d="M13.0371 0.324219H19.2291V12.7092H13.0371V0.324219Z" fill="#01FF4E" />
                              <path d="M11.7329 1.62891H17.9249V14.0789H11.7329V1.62891Z" fill="#01FF4E" />
                              <path d="M13.0371 3.58959V12.1206C13.123 12.1209 13.208 12.138 13.2872 12.1711C13.3665 12.2043 13.4384 12.2526 13.499 12.3136C13.5595 12.3745 13.6075 12.4467 13.6401 12.5262C13.6727 12.6056 13.6894 12.6907 13.6891 12.7766H15.9701C15.9699 12.6907 15.9865 12.6056 16.0191 12.5262C16.0518 12.4467 16.0997 12.3745 16.1602 12.3136C16.2208 12.2526 16.2927 12.2043 16.372 12.1711C16.4512 12.138 16.5362 12.1209 16.6221 12.1206V3.58959C16.5362 3.58933 16.4512 3.57216 16.372 3.53905C16.2927 3.50594 16.2208 3.45754 16.1602 3.39663C16.0997 3.33571 16.0518 3.26347 16.0191 3.18402C15.9865 3.10457 15.9699 3.01948 15.9701 2.93359H13.6891C13.6894 3.01948 13.6727 3.10457 13.6401 3.18402C13.6075 3.26347 13.5595 3.33571 13.499 3.39663C13.4384 3.45754 13.3665 3.50594 13.2872 3.53905C13.208 3.57216 13.123 3.58933 13.0371 3.58959Z" fill="#01FF4E" />
                              <path d="M4.88916 6.90547H9.12616L11.7332 5.60547V6.90547H17.5992C17.7302 6.90128 17.8607 6.92347 17.9829 6.9707C18.1052 7.01794 18.2167 7.08927 18.3108 7.18045C18.405 7.27163 18.4798 7.38081 18.531 7.5015C18.5821 7.62218 18.6084 7.7519 18.6084 7.88297C18.6084 8.01403 18.5821 8.14377 18.531 8.26445C18.4798 8.38513 18.405 8.49431 18.3108 8.58549C18.2167 8.67668 18.1052 8.748 17.9829 8.79524C17.8607 8.84248 17.7302 8.86466 17.5992 8.86047H16.9472C17.201 8.86859 17.4417 8.97513 17.6184 9.15756C17.7951 9.33999 17.8939 9.584 17.8939 9.83797C17.8939 10.0919 17.7951 10.3359 17.6184 10.5184C17.4417 10.7008 17.201 10.8074 16.9472 10.8155H16.2952C16.549 10.8236 16.7897 10.9301 16.9664 11.1126C17.1431 11.295 17.2419 11.539 17.2419 11.793C17.2419 12.0469 17.1431 12.2909 16.9664 12.4734C16.7897 12.6558 16.549 12.7623 16.2952 12.7705H15.6432C15.7742 12.7663 15.9047 12.7885 16.0269 12.8357C16.1492 12.8829 16.2607 12.9543 16.3548 13.0455C16.449 13.1366 16.5238 13.2458 16.575 13.3665C16.6261 13.4872 16.6524 13.6169 16.6524 13.748C16.6524 13.879 16.6261 14.0088 16.575 14.1294C16.5238 14.2501 16.449 14.3593 16.3548 14.4505C16.2607 14.5417 16.1492 14.613 16.0269 14.6602C15.9047 14.7075 15.7742 14.7297 15.6432 14.7255H10.7542L4.88916 13.7535V6.90547Z" fill="#FFEAD6" />
                              <path d="M0.326172 6.91016H6.84417V15.3842H0.326172V6.91016Z" fill="#7671FF" />
                              <path d="M4.42207 14.3139C5.01357 14.3139 5.49307 13.8344 5.49307 13.2429C5.49307 12.6514 5.01357 12.1719 4.42207 12.1719C3.83058 12.1719 3.35107 12.6514 3.35107 13.2429C3.35107 13.8344 3.83058 14.3139 4.42207 14.3139Z" fill="white" />
                              <path d="M19.229 0H13.036C12.9494 0.000264687 12.8665 0.0348346 12.8054 0.0961304C12.7443 0.157426 12.71 0.240447 12.71 0.327V1.309H11.732C11.6454 1.30926 11.5625 1.34383 11.5014 1.40513C11.4403 1.46642 11.406 1.54945 11.406 1.636V5.361L9.049 6.546H0.326C0.239448 6.54627 0.156531 6.58083 0.0954223 6.64213C0.034314 6.70342 -4.04718e-07 6.78645 0 6.873L0 15.382C-4.04718e-07 15.4686 0.034314 15.5516 0.0954223 15.6129C0.156531 15.6742 0.239448 15.7087 0.326 15.709H6.844C6.93055 15.7087 7.01347 15.6742 7.07458 15.6129C7.13569 15.5516 7.17 15.4686 7.17 15.382V14.459L10.701 15.05C10.719 15.0515 10.737 15.0515 10.755 15.05H15.644C15.872 15.0488 16.0958 14.9877 16.2927 14.8727C16.4896 14.7577 16.6529 14.593 16.766 14.395H17.925C18.0116 14.3947 18.0945 14.3602 18.1556 14.2989C18.2167 14.2376 18.251 14.1546 18.251 14.068V13.086H19.229C19.3156 13.0857 19.3985 13.0512 19.4596 12.9899C19.5207 12.9286 19.555 12.8456 19.555 12.759V0.327C19.555 0.240447 19.5207 0.157426 19.4596 0.0961304C19.3985 0.0348346 19.3156 0.000264687 19.229 0ZM12.059 1.964H17.6V6.546H16.948V3.6C16.948 3.51345 16.9137 3.43042 16.8526 3.36913C16.7915 3.30783 16.7086 3.27326 16.622 3.273C16.5354 3.27273 16.4525 3.23817 16.3914 3.17687C16.3303 3.11558 16.296 3.03255 16.296 2.946C16.296 2.85945 16.2617 2.77643 16.2006 2.71513C16.1395 2.65383 16.0566 2.61926 15.97 2.619H13.688C13.6014 2.61926 13.5185 2.65383 13.4574 2.71513C13.3963 2.77643 13.362 2.85945 13.362 2.946C13.362 3.03255 13.3277 3.11558 13.2666 3.17687C13.2055 3.23817 13.1226 3.27273 13.036 3.273C12.9494 3.27326 12.8665 3.30783 12.8054 3.36913C12.7443 3.43042 12.71 3.51345 12.71 3.6V6.546H12.058L12.059 1.964ZM16.3 6.546H13.362V3.871C13.5004 3.82202 13.6261 3.74273 13.7299 3.63892C13.8337 3.53511 13.913 3.4094 13.962 3.271H15.7C15.749 3.4094 15.8283 3.53511 15.9321 3.63892C16.0359 3.74273 16.1616 3.82202 16.3 3.871V6.546ZM6.518 15.055H0.652V7.2H6.518V15.055ZM14.992 13.091H15.644C15.8132 13.0976 15.9732 13.1695 16.0905 13.2915C16.2079 13.4135 16.2734 13.5762 16.2734 13.7455C16.2734 13.9148 16.2079 14.0775 16.0905 14.1995C15.9732 14.3215 15.8132 14.3934 15.644 14.4H10.782L7.17 13.8V7.2H9.125C9.17565 7.2002 9.22565 7.18856 9.271 7.166L11.407 6.093V6.873C11.407 6.95955 11.4413 7.04257 11.5024 7.10387C11.5635 7.16517 11.6464 7.19974 11.733 7.2H17.6C17.7692 7.20661 17.9292 7.27846 18.0465 7.40048C18.1639 7.5225 18.2294 7.68521 18.2294 7.8545C18.2294 8.02379 18.1639 8.1865 18.0465 8.30852C17.9292 8.43054 17.7692 8.50239 17.6 8.509H16.3C16.2131 8.509 16.1298 8.5435 16.0684 8.60492C16.007 8.66634 15.9725 8.74964 15.9725 8.8365C15.9725 8.92336 16.007 9.00666 16.0684 9.06808C16.1298 9.1295 16.2131 9.164 16.3 9.164H16.952C17.1212 9.17062 17.2812 9.24246 17.3985 9.36448C17.5159 9.4865 17.5814 9.64921 17.5814 9.8185C17.5814 9.98779 17.5159 10.1505 17.3985 10.2725C17.2812 10.3945 17.1212 10.4664 16.952 10.473H15.652C15.5651 10.473 15.4818 10.5075 15.4204 10.5689C15.359 10.6303 15.3245 10.7136 15.3245 10.8005C15.3245 10.8874 15.359 10.9707 15.4204 11.0321C15.4818 11.0935 15.5651 11.128 15.652 11.128H16.3C16.4692 11.1346 16.6292 11.2065 16.7465 11.3285C16.8639 11.4505 16.9294 11.6132 16.9294 11.7825C16.9294 11.9518 16.8639 12.1145 16.7465 12.2365C16.6292 12.3585 16.4692 12.4304 16.3 12.437H15C14.9131 12.437 14.8298 12.4715 14.7684 12.5329C14.707 12.5943 14.6725 12.6776 14.6725 12.7645C14.6725 12.8514 14.707 12.9347 14.7684 12.9961C14.8298 13.0575 14.9131 13.092 15 13.092L14.992 13.091ZM17.599 13.746H16.947C16.9472 13.4868 16.8702 13.2334 16.726 13.018C16.914 12.9511 17.0843 12.8423 17.2239 12.6997C17.3635 12.5571 17.4687 12.3846 17.5316 12.1952C17.5944 12.0058 17.6133 11.8046 17.5867 11.6069C17.5601 11.4091 17.4887 11.22 17.378 11.054C17.4549 11.0262 17.5289 10.991 17.599 10.949V13.746ZM18.899 7.855V12.437H18.247V8.985C18.4461 8.87134 18.6116 8.70703 18.7268 8.50875C18.8419 8.31047 18.9025 8.08528 18.9025 7.856C18.9025 7.62672 18.8419 7.40153 18.7268 7.20325C18.6116 7.00497 18.4461 6.84067 18.247 6.727V1.636C18.247 1.54945 18.2127 1.46642 18.1516 1.40513C18.0905 1.34383 18.0076 1.30926 17.921 1.309H13.362V0.653999H18.9L18.899 7.855Z" fill="black" />
                              <path d="M4.55879 11.8008C4.30168 11.8008 4.05033 11.877 3.83655 12.0199C3.62277 12.1627 3.45614 12.3658 3.35774 12.6033C3.25935 12.8408 3.23361 13.1022 3.28377 13.3544C3.33393 13.6066 3.45774 13.8382 3.63955 14.02C3.82136 14.2018 4.05299 14.3256 4.30517 14.3758C4.55735 14.426 4.81873 14.4002 5.05628 14.3018C5.29382 14.2034 5.49686 14.0368 5.6397 13.823C5.78255 13.6092 5.85879 13.3579 5.85879 13.1008C5.85879 12.756 5.72183 12.4253 5.47803 12.1815C5.23423 11.9378 4.90358 11.8008 4.55879 11.8008ZM4.55879 13.7558C4.42984 13.7558 4.30378 13.7175 4.19656 13.6459C4.08934 13.5743 4.00577 13.4724 3.95642 13.3533C3.90707 13.2342 3.89416 13.1031 3.91932 12.9766C3.94448 12.8501 4.00657 12.7339 4.09776 12.6428C4.18894 12.5516 4.30511 12.4895 4.43159 12.4643C4.55806 12.4391 4.68916 12.4521 4.8083 12.5014C4.92744 12.5508 5.02927 12.6343 5.10091 12.7415C5.17255 12.8488 5.21079 12.9748 5.21079 13.1038C5.21079 13.2767 5.1421 13.4425 5.01982 13.5648C4.89755 13.6871 4.73172 13.7558 4.55879 13.7558Z" fill="black" />
                            </g>
                            <defs>
                              <clipPath id="clip0_2389_45009">
                                <rect width="19.555" height="15.71" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                        {t("contest.to_pay")}
                      </h4>
                      <h4 class={` mb-0 ${premiumUser ? "text-light" : ""}`}>
                        {
                          tournaments?.entryFee > 0 ?
                            <span class="icon me-2">
                              {
                                tournaments?.entryFee > 0 && !premiumUser &&
                                <img
                                  src={
                                    url.imageUrl +
                                    tournaments?.currency[0]?.inCurrency?.img?.default
                                  }
                                  class="icon-24 "
                                  alt=""
                                />
                              }

                            </span>
                            : ""
                        }

                        {tournaments?.entryFee > 0 && !premiumUser ? walletData?.toPay : t("tournaments.free")}
                      </h4>
                    </li>
                    {
                      premiumUser && tournaments?.entryFee > 0 && (
                        <li class="list-group-item d-flex justify-content-between px-0 py-3">
                          <h4 class="bodyBoldFont mb-0 text-capitalize">

                            {/* {tournaments?.currency?.[0]?.inCurrency?.code === "D11" ? "Diamond" : "Coin"} Saved */}
                            {t('tournaments.saved', { coin: `${tournaments?.currency?.[0]?.inCurrency?.code}` })}

                          </h4>
                          <h4 class="mb-0">
                            {
                              tournaments?.entryFee > 0 ?
                                <span class="icon me-2">
                                  <img
                                    src={
                                      url.imageUrl +
                                      tournaments?.currency[0]?.inCurrency?.img?.default
                                    }
                                    class="icon-24"
                                    alt=""
                                  />
                                </span>
                                : ""
                            }

                            {tournaments?.entryFee > 0 ? walletData?.toPay : t("tournaments.free")}
                          </h4>
                        </li>
                      )
                    }
                  </ul>
                </div>
                <div class="row justify-content-center mt-4 pt-2">
                  <div class="col-lg-7">
                    <div class="d-grid">
                      <button
                        class={premiumUser ? "btn btn-golden" : "btn btn-primary btn-arrow"}
                        onClick={handlerJoinContest}
                        disabled={contestDisabled}
                      >
                        {tournaments?.isJoined ? t("tournaments.joined") : t("contest.join_contest")}
                      </button>
                    </div>
                  </div>
                  <div className="mt-4" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>

                    <GoogleAds
                      adUnitPath="/157165500,23206251223/MCM_Gj_Console/MCM_Gj_Console_banner_1"
                      sizes={[[728, 90], [336, 280]]}
                      divId={`gpt-banner-1`}
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {showTeamRegisterModal && (
        <TeamRegisterModal
          showTeamRegisterModal={showTeamRegisterModal}
          setShowTeamRegisterModal={setShowTeamRegisterModal}
          postData={postData}
          type={"contest"}
          noOfPlayer={noOfPlayer}
          setShowTournamentConfirmationModal={setShowContestConfirmationModal}
          game={game}
          setShowPremiumPopupTournament={setShowPremiumPopupContest}
          userInGameName={userInGameName}
        />
      )}
    </>
  );
};

export default ContestConfirmationModel;
